module.exports = __webpack_public_path__ + "src/assets/img/orders-bg.d10ce3cb.png";